import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { registerPlugins } from './plugins';
import VueApexCharts from 'vue-apexcharts';
import VuetifyMoney from './modules/shared/components/VuetifyMoney.vue';
import * as Sentry from '@sentry/vue';
import formatMixin from './mixins/format.mixin';
import { AuthorizeDirective } from './directives/Authorize';
import './styles/style.css';
import 'driver.js/dist/driver.css';
import {
  ROOT_API,
  APP_DOMAIN,
  SENTRY_DSN,
  SENTRY_TRACES_SAMPLE_RATE,
  SENTRY_REPLAY_SESSION_SAMPLE_RATE,
  SENTRY_REPLAY_ONERROR_SAMPLE_RATE
} from './lib/constants/env';
import ECLMoreDetails from '@/modules/ifrs9/components/ag-grid/ECLMoreDetails.vue';
import CreditMoreDetails from '@/modules/ifrs9/components/ag-grid/CreditMoreDetails.vue';
import CollatMoreDetails from '@/modules/ifrs9/components/ag-grid/CollatMoreDetails.vue';
import Toasted from 'vue-toasted';

import vueHljs from 'vue-hljs';
import hljs from 'highlight.js';
import 'highlight.js/styles/atom-one-light.css';

import '../src/modules/shared/reports-kit/styles/report-theme.css';

Vue.use(vueHljs, { hljs });

Vue.directive('auth', AuthorizeDirective);
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);
Vue.component('vuetify-money', VuetifyMoney);
Vue.component('ECLMoreDetails', ECLMoreDetails);
Vue.component('CreditMoreDetails', CreditMoreDetails);
Vue.component('CollatMoreDetails', CollatMoreDetails);
Vue.mixin(formatMixin);

Vue.use(Toasted, {
  position: 'top-center',
  duration: 5000,
  keepOnHover: true
  // theme: 'bubble'
});

Sentry.init({
  Vue,
  dsn: SENTRY_DSN,
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: [APP_DOMAIN, ROOT_API],
      routingInstrumentation: Sentry.vueRouterInstrumentation(router)
    }),
    new Sentry.Replay()
  ],
  // Performance Monitoring
  tracesSampleRate: +SENTRY_TRACES_SAMPLE_RATE,
  // Session Replay
  replaysSessionSampleRate: +SENTRY_REPLAY_SESSION_SAMPLE_RATE,
  replaysOnErrorSampleRate: +SENTRY_REPLAY_ONERROR_SAMPLE_RATE
});

Vue.config.productionTip = false;

registerPlugins(Vue);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount('#app');
